
export default function FlashResultsScoreCardContentLayout({children}) {
    // Used in FlashResultsScoreCard to frame score content layout
    // in desktop mode

    // BUILD
    return (
        <div className={"w-full grow flex justify-around px-16"}>
            {children}
        </div>
    );
}